import * as React from 'react';
import Box from "@mui/material/Box";

export default function Logo({
                                 src = '/images/logo/logo.png',
                                 alt = 'Logo',
                             }: {
    src?: string;
    alt?: string;
}) {
    return (
        <Box
            component="img"
            width="1em"
            height="1em"
            display="block"
            src={src}
            alt={alt}
            pt={.2}
            px={.2}
            sx={{
                objectFit: 'contain',
            }}
        />
    );
}